import type { Suggestions } from '@mint-sdk/api-recommendations';

import type { SuggestionGridType } from '../types/suggestion.js';

export const prepareGridData = (
  suggestion: Suggestions.SuggestionResponseType,
  isMultiCurrency: boolean,
) => {
  const {
    taxonomy: { children },
    currency,
  } = suggestion;

  const result: SuggestionGridType[] = [];

  children.forEach((child) => {
    const childResults = flattenNodeSuggestion(
      child,
      currency,
      isMultiCurrency,
    );
    result.push(...childResults);
  });

  return result;
};

const flattenNodeSuggestion = (
  node: Suggestions.TaxonomyChildrenType,
  currency: string,
  isMultiCurrency: boolean,
  parentId?: SuggestionGridType['id'],
): SuggestionGridType[] => {
  // Initialize result array
  const result: SuggestionGridType[] = [];

  // Create current node without children
  const { children, budgetData, multicurrencyBudgetData, type, ...allData } =
    node;

  const shouldDisplayMulticurrency =
    !['platform', 'channel'].includes(type) &&
    isMultiCurrency &&
    multicurrencyBudgetData;

  // Add to result array with parentId and budget data
  result.push({
    ...allData,
    type,
    budgetType: budgetData.budgetType,
    oldBudget: shouldDisplayMulticurrency
      ? multicurrencyBudgetData.currentBudget
      : budgetData.currentBudget,
    newBudget: shouldDisplayMulticurrency
      ? multicurrencyBudgetData.proposedBudget
      : budgetData.proposedBudget,
    currency: shouldDisplayMulticurrency
      ? multicurrencyBudgetData.currency
      : currency,
    parentId: parentId?.toString() || null,
  });
  // Process children recursively
  if (children && Array.isArray(children)) {
    children.forEach((child) => {
      // Concatenate results from recursive calls
      const childResults = flattenNodeSuggestion(
        child,
        currency,
        isMultiCurrency,
        node.id,
      );
      result.push(...childResults);
    });
  }

  return result;
};
